const itServicesData = [
    {
      id: "website-creation",
      title: "Website Creation",
      shortDescription: "Custom, responsive websites built to grow your business.",
      image: "/IT/website.jpg",
      details: `Our Website Creation service offers end-to-end solutions—from modern design and responsive development to SEO-friendly architecture. We work closely with you to understand your brand and create a website that drives user engagement and business growth. 
  Typical projects run between 4-8 weeks, including planning, design, development, testing, and launch.`
    },
    {
      id: "digital-marketing",
      title: "Digital Marketing",
      shortDescription: "Boost your online presence with data-driven digital strategies.",
      image: "/IT/dm.jpg",
      details: `Our Digital Marketing service leverages SEO, PPC, social media, content marketing, and email campaigns to elevate your brand online. We craft tailored strategies backed by analytics and creative execution. 
  Campaigns are customized to your goals, with ongoing optimization to ensure a high return on investment.`
    },
    {
      id: "it-support",
      title: "On Site and Remote IT Support",
      shortDescription: "Reliable technical support to keep your business running smoothly.",
      image: "/IT/support.webp",
      details: `Our IT Support service provides both on-site and remote assistance to resolve technical issues, maintain hardware and software, and ensure your IT infrastructure is secure. 
  We offer flexible service plans that minimize downtime and are tailored to your business needs.`
    },
    {
      id: "cctv-installation",
      title: "CCTV Installation",
      shortDescription: "Professional surveillance systems for enhanced security.",
      image: "/IT/cctv.jpg",
      details: `Our CCTV Installation service delivers a complete security solution—from selecting the right cameras to full system installation and configuration. 
  We work with trusted brands to provide reliable surveillance systems that suit your environment. Installation times vary by project scope.`
    },
    {
      id: "attendance",
      title: "Attendance System Installation",
      shortDescription: "Modern attendance tracking solutions to streamline workforce management.",
      image: "/IT/attendance.jpg",
      details: `Our Attendance System Installation service installs state-of-the-art biometric and RFID-based systems to accurately track employee attendance. 
  We integrate these systems with reporting tools to help manage productivity and payroll. Project timelines depend on the scale of your organization.`
    }
  ];
  
  export default itServicesData;
  